import React, { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import api from '../services/api';

/**
 * ProtectedRoute - Vérifie l'authentification AVANT de rendre le composant
 * Empêche le flash de contenu non autorisé
 */
function ProtectedRoute({ children }) {
  const [isAuthenticated, setIsAuthenticated] = useState(null); // null = en cours de vérification

  useEffect(() => {
    const checkAuth = async () => {
      const token = localStorage.getItem('token');
      if (!token) {
        setIsAuthenticated(false);
        return;
      }

      // Vérifier que le token est valide en faisant un appel authentifié
      try {
        await api.getProfile();
        setIsAuthenticated(true);
      } catch (error) {
        // Token invalide ou expiré
        localStorage.removeItem('token');
        setIsAuthenticated(false);
      }
    };

    checkAuth();
  }, []);

  // Pendant la vérification, ne rien afficher (ou un spinner discret)
  if (isAuthenticated === null) {
    return null;
  }

  // Si non authentifié, rediriger vers /chat (qui affichera le login)
  if (!isAuthenticated) {
    return <Navigate to="/chat" replace />;
  }

  // Authentifié : afficher le composant
  return children;
}

export default ProtectedRoute;
